// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import {TaglineText, FootnoteText} from '../core/Type';
import {FixedSpace} from '../core/Spacing';
// Layouts
import {Grid, GridRow, GridColumn} from '../layouts/Grid';

export default class SiteFooter extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                backgroundColor: CoreMetrics.Color.Neutral.XDarkGray,
                paddingTop: CoreMetrics.ElementSpacing.XLarge(),
                paddingBottom: CoreMetrics.ElementSpacing.XLarge(),
            },
            small: {
                [CoreMetrics.MediaQuery().Phone]: {
                    display: "flex",
                },
                [CoreMetrics.MediaQuery().Tablet]: {
                    display: "none",
                },
                [CoreMetrics.MediaQuery().Desktop]: {
                    display: "none",
                },
            },
            large: {
                [CoreMetrics.MediaQuery().Phone]: {
                    display: "none",
                },
                [CoreMetrics.MediaQuery().Tablet]: {
                    display: "flex",
                },
                [CoreMetrics.MediaQuery().Desktop]: {
                    display: "flex",
                },
            },
            text: {
                color: CoreMetrics.Color.Neutral.White,
            },
        });

        const aboutLinksStrings = [
            "About",
            "News",
            "Impact",
            "Our team",
            "Our interns",
            "Our content specialists",
            "Our leadership",
            "Our supporters",
            "Our contributors",
            "Careers",
            "Internships",
        ];
        const aboutLinks = <FooterLinks linkStrings={aboutLinksStrings} />;

        const contactLinksStrings = [
            "Contact",
            "Help center",
            "Support community",
            "Share your story",
            "Press",
        ];
        const contactLinks = <FooterLinks linkStrings={contactLinksStrings} />;

        const downloadLinksStrings = [
            "Download our apps",
            "iOS app",
            "Android app",
        ];
        const downloadLinks = <FooterLinks
            linkStrings={downloadLinksStrings}
        />;

        const domainLinksStrings = [
            "Subjects",
            "Math by subject",
            "Math by grade",
            "Science & engineering",
            "Computing",
            "Arts & humanities",
            "Economics & finance",
            "Test prep",
            "College, careers, & more",
        ];
        const domainLinks = <FooterLinks linkStrings={domainLinksStrings} />;

        const missionContent = (
            <div>
                <TaglineText styles={[styles.text]}>
                    Our mission is to provide a free, world-class education to
                    anyone, anywhere.
                </TaglineText>
                <FixedSpace
                    variant={FixedSpace.Variant.Vertical}
                    size={FixedSpace.Size.Medium}
                />
                <TaglineText styles={[styles.text]}>
                    Khan Academy is a 501(c)(3) nonprofit organization. Donate
                    or volunteer today!
                </TaglineText>
            </div>
        );
        const smallLayout = (
            <Grid styles={[styles.small]}>
                <GridRow>
                    <GridColumn>{missionContent}</GridColumn>
                </GridRow>
                <FixedSpace
                    variant={FixedSpace.Variant.Vertical}
                    size={FixedSpace.Size.XLarge}
                />
                <GridRow>
                    <GridColumn variant={GridColumn.Variant.OneHalf}>
                        {aboutLinks}
                        {contactLinks}
                    </GridColumn>
                    <GridColumn variant={GridColumn.Variant.OneHalf}>
                        {downloadLinks}
                        {domainLinks}
                    </GridColumn>
                </GridRow>
            </Grid>
        );
        const largeLayout = (
            <Grid styles={[styles.large]}>
                <GridRow>
                    <GridColumn>{missionContent}</GridColumn>
                    <GridColumn variant={GridColumn.Variant.OneSixth}>
                        {aboutLinks}
                    </GridColumn>
                    <GridColumn variant={GridColumn.Variant.OneSixth}>
                        {contactLinks}
                        {downloadLinks}
                    </GridColumn>
                    <GridColumn variant={GridColumn.Variant.OneSixth}>
                        {domainLinks}
                    </GridColumn>
                </GridRow>
            </Grid>
        );
        return (
            <div className={css(styles.container)}>
                {smallLayout}
                {largeLayout}

                {/* <OneContentColumnLayout column1={missionContent} />

                <FourColumnLayout
                    column1={aboutLinks}
                    column2={contactLinks}
                    column3={downloadLinks}
                    column4={domainLinks} />
                */}
            </div>
        );
    }
}

const FooterLinks = (props) => {
    const styles = createExpandableMediaQueryStylesheet({
        linkList: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
        },
        link: {
            color: CoreMetrics.Color.Neutral.White,
        },
    });

    return <div className={css(styles.linkList)}>
        {props.linkStrings.map((string, index) =>
            <FootnoteText
                key={`footerlink${index}`}
                styles={[styles.link]}
            >
                {string}
            </FootnoteText>
        )}
    </div>;
};



// WEBPACK FOOTER //
// ./src/modules/SiteFooter.jsx